import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Account deletion'}),
    routes: [
        {
            // the request id and the code used to reach the page as data attributes
            // on its mount point; django put them there straight from these very
            // url kwargs, so the route reads them itself
            path: '/users/delete/:requestId(\\d+)/:userId(\\d+)/confirmation/:requestCode/',
            component: () => import(/* webpackChunkName: "accountPages" */ './CloseAccountConfirmationPage.vue'),
            name: 'CloseAccountConfirmationPage',
            props: route => ({
                requestId: route.params.requestId,
                requestCode: route.params.requestCode,
            }),
        },
    ]
});
